import {
    Accessibility,
    AlignCenter,
    AlignLeft,
    AlignRight,
    Angry,
    Archive,
    ArrowDownNarrowWide,
    ArrowDownRight,
    ArrowLeft,
    ArrowRight,
    ArrowRightLeft,
    ArrowUpDown,
    ArrowUpNarrowWide,
    ArrowUpRight,
    ArrowUpRightFromSquare,
    AtSign,
    Award,
    Baby,
    Badge,
    BadgeDollarSign,
    BarChart3,
    Bolt,
    Book,
    BookOpen,
    Bookmark,
    BookmarkX,
    Bot,
    Brain,
    Briefcase,
    Building,
    Building2,
    Cake,
    Calendar,
    CalendarDays,
    Camera,
    Car,
    Check,
    CheckCircle,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleAlert,
    CircleDot,
    CircleHelp,
    ClipboardList,
    Clock,
    Cloud,
    Code2,
    Cog,
    Coins,
    Columns3,
    Compass,
    Contact,
    Copy,
    Crosshair,
    Crown,
    Dices,
    DollarSign,
    Download,
    Drama,
    Edit,
    Egg,
    Ellipsis,
    Eraser,
    ExternalLink,
    Eye,
    EyeOff,
    File,
    FileSignature,
    FileSpreadsheet,
    FileText,
    Film,
    Filter,
    Flag,
    FlagTriangleRight,
    Flame,
    Flower2,
    Frown,
    Gamepad,
    Gamepad2,
    Gauge,
    Gift,
    Glasses,
    Globe,
    GraduationCap,
    GripHorizontal,
    Hand,
    HandHeart,
    Handshake,
    HardHat,
    Hash,
    Heart,
    HeartPulse,
    Home,
    Hourglass,
    Image,
    Info,
    Key,
    Languages,
    Laptop,
    Laugh,
    Layers,
    Leaf,
    Lightbulb,
    LineChart,
    Link,
    List,
    ListChecks,
    ListFilter,
    ListOrdered,
    ListTree,
    LoaderCircle,
    Lock,
    LogIn,
    Mail,
    MailOpen,
    Mails,
    Medal,
    Megaphone,
    Meh,
    MemoryStick,
    MessageCircleMore,
    MessageSquare,
    MessagesSquare,
    Mic,
    Microscope,
    MousePointer,
    MousePointerClick,
    Music,
    PackageOpen,
    Paintbrush,
    Paperclip,
    Pen,
    PieChart,
    Play,
    Plus,
    Presentation,
    Puzzle,
    Quote,
    Radio,
    RadioTower,
    RefreshCw,
    Repeat,
    Reply,
    Rocket,
    RotateCcw,
    Ruler,
    Save,
    Scale,
    ScanFace,
    Scroll,
    Search,
    Send,
    Settings,
    Shield,
    Shirt,
    ShoppingCart,
    Skull,
    Smartphone,
    Smile,
    Sparkles,
    SquarePen,
    SquareUser,
    StarHalf,
    Sun,
    TextCursorInput,
    ThumbsUp,
    Timer,
    Tractor,
    Trash,
    Trash2,
    TrendingDown,
    TrendingUp,
    TriangleAlert,
    Trophy,
    Unlink,
    Unlock,
    Upload,
    User,
    UserCheck,
    UserPlus,
    UserRound,
    UserRoundCheck,
    UserRoundCog,
    Users,
    UsersRound,
    VenetianMask,
    Video,
    VideoOff,
    WandSparkles,
    Wrench,
    X,
} from 'lucide-vue-next'

export const APP_ICONS = {
    'align-center': AlignCenter,
    'align-left': AlignLeft,
    'align-right': AlignRight,
    angry: Angry,
    archive: Archive,
    'arrow-down-right': ArrowDownRight,
    'arrow-down-wide-short': ArrowDownNarrowWide,
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'arrow-trend-down': TrendingDown,
    'arrow-trend-up': TrendingUp,
    'arrow-up-arrow-down': ArrowUpDown,
    'arrow-up-right': ArrowUpRight,
    'arrow-up-right-from-square': ArrowUpRightFromSquare,
    'arrow-up-short-wide': ArrowUpNarrowWide,
    'arrows-rotate': RefreshCw,
    at: AtSign,
    award: Award,
    'balance-scale': Scale,
    'ballot-check': ListChecks,
    'basketball-ball': CircleDot,
    bolt: Bolt,
    book: Book,
    'book-open': BookOpen,
    bookmark: Bookmark,
    'bookmark-slash': BookmarkX,
    'box-open': PackageOpen,
    brain: Brain,
    briefcase: Briefcase,
    'broadcast-tower': RadioTower,
    building: Building,
    bullhorn: Megaphone,
    'bullseye-pointer': Crosshair,
    'cake-candles': Cake,
    calendar: Calendar,
    'calendar-alt': Calendar,
    'calendar-circle-user': CalendarDays,
    camera: Camera,
    'camera-retro': Camera,
    car: Car,
    'caret-down': ChevronDown,
    'cart-shopping': ShoppingCart,
    'chalkboard-teacher': Presentation,
    'chart-bar': BarChart3,
    'chart-line': LineChart,
    'chart-pie': PieChart,
    check: Check,
    'check-circle': CheckCircle,
    chess: Crown,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    child: Baby,
    'circle-exclamation': CircleAlert,
    'circle-info': Info,
    'circle-question': CircleHelp,
    city: Building2,
    'clipboard-list': ClipboardList,
    clock: Clock,
    cloud: Cloud,
    cog: Cog,
    cogs: Settings,
    coins: Coins,
    'comment-alt': MessageSquare,
    'comment-dots': MessageCircleMore,
    comments: MessagesSquare,
    compass: Compass,
    copy: Copy,
    crown: Crown,
    dice: Dices,
    'dollar-sign': DollarSign,
    download: Download,
    edit: Edit,
    egg: Egg,
    ellipsis: Ellipsis,
    'engine-warning': TriangleAlert,
    envelope: Mail,
    'envelope-open': MailOpen,
    'envelope-open-text': Mails,
    eraser: Eraser,
    'exchange-alt': ArrowRightLeft,
    'exclamation-circle': CircleAlert,
    'exclamation-triangle': TriangleAlert,
    'external-link-alt': ExternalLink,
    eye: Eye,
    'eye-slash': EyeOff,
    'face-grin': Smile,
    family: Users,
    file: File,
    'file-contract': FileSignature,
    'file-csv': FileSpreadsheet,
    'file-pdf': FileText,
    'file-text': FileText,
    'file-word': FileText,
    film: Film,
    'film-alt': Film,
    filter: Filter,
    filters: ListFilter,
    fire: Flame,
    'fire-alt': Flame,
    'fist-raised': Hand,
    flag: Flag,
    'flag-pennant': FlagTriangleRight,
    'floppy-disk-circle-arrow-right': Save,
    frown: Frown,
    gamepad: Gamepad,
    'gamepad-modern': Gamepad2,
    gauge: Gauge,
    gear: Settings,
    gift: Gift,
    glasses: Glasses,
    globe: Globe,
    'graduation-cap': GraduationCap,
    'grin-stars': Sparkles,
    'grin-tongue': Laugh,
    'grip-lines': GripHorizontal,
    'hand-heart': HandHeart,
    'hand-pointer': MousePointerClick,
    'hands-helping': Handshake,
    handshake: Handshake,
    hashtag: Hash,
    'hat-cowboy': HardHat,
    'hat-wizard': WandSparkles,
    heart: Heart,
    'heart-pulse': HeartPulse,
    heartbeat: HeartPulse,
    home: Home,
    hourglass: Hourglass,
    'id-badge': Badge,
    'id-card': Contact,
    image: Image,
    'info-circle': Info,
    'input-text': TextCursorInput,
    'journal-whills': BookOpen,
    key: Key,
    language: Languages,
    laptop: Laptop,
    'laptop-code': Code2,
    laugh: Laugh,
    'laugh-beam': Laugh,
    'layer-group': Layers,
    leaf: Leaf,
    lightbulb: Lightbulb,
    'line-columns': Columns3,
    link: Link,
    list: List,
    'list-ol': ListOrdered,
    'list-ul': List,
    lock: Lock,
    magic: WandSparkles,
    'magnifying-glass': Search,
    mask: VenetianMask,
    medal: Medal,
    meh: Meh,
    memory: MemoryStick,
    'messages-dollar': BadgeDollarSign,
    'microphone-alt': Mic,
    microscope: Microscope,
    'mobile-alt': Smartphone,
    'mouse-pointer': MousePointer,
    music: Music,
    'paint-brush': Paintbrush,
    paperclip: Paperclip,
    'paper-plane': Send,
    pen: Pen,
    'pen-to-square': SquarePen,
    play: Play,
    plus: Plus,
    'puzzle-piece': Puzzle,
    question: CircleHelp,
    'quote-left': Quote,
    'rectangle-list': List,
    repeat: Repeat,
    reply: Reply,
    robot: Bot,
    'rocket-launch': Rocket,
    'rotate-left': RotateCcw,
    'ruler-vertical': Ruler,
    scroll: Scroll,
    search: Search,
    'shield-alt': Shield,
    'shield-halved': Shield,
    'sign-in-alt': LogIn,
    'signal-stream': Radio,
    'skull-crossbones': Skull,
    'smile-beam': Smile,
    'smile-wink': Smile,
    spa: Flower2,
    sparkles: Sparkles,
    spinner: LoaderCircle,
    'spinner-third': LoaderCircle,
    'square-user': SquareUser,
    'star-half-alt': StarHalf,
    stopwatch: Timer,
    stream: ListTree,
    'street-view': Accessibility,
    sun: Sun,
    sync: RefreshCw,
    'theater-masks': Drama,
    'thumbs-up': ThumbsUp,
    times: X,
    tools: Wrench,
    tractor: Tractor,
    trash: Trash,
    'trash-alt': Trash2,
    'trash-can': Trash2,
    'triangle-exclamation': TriangleAlert,
    trophy: Trophy,
    tshirt: Shirt,
    unlink: Unlink,
    unlock: Unlock,
    upload: Upload,
    user: User,
    'user-alt': User,
    'user-astronaut': UserRound,
    'user-check': UserCheck,
    'user-group': Users,
    'user-lock': UserRoundCog,
    'user-plus': UserPlus,
    'user-secret': Shield,
    'user-tie': UserRound,
    'user-unlock': UserRoundCheck,
    users: Users,
    'users-viewfinder': ScanFace,
    'venus-mars': UsersRound,
    video: Video,
    'video-slash': VideoOff,
    'vr-cardboard': Glasses,
    'wand-magic-sparkles': WandSparkles,
    wheelchair: Accessibility,
    xmark: X,
}
